module.exports = __webpack_public_path__ + "static/media/TG-logo-8-2.ee21f139.png";